import React from "react";
import BestOverAll from "@components/category/bestOverAll";

import CategoryTemplate from "@components/category/categoryTemplate";
import StickyComponent from "@components/category/bestOverAll/stickyComponent";
import { useAtom } from "jotai";
import { comparisonVendors } from "@store/categoryStore";
import MetaTags from "@components/shared/metaTags";
import { useQuery } from "@tanstack/react-query";
import { GQLCategories, GQLDomains, GQLUrls } from "@gql/types/gql";
import {
    getCategoriesDescription,
    getCategoriesKeyWords,
    resolveURL,
} from "@lib/sharedUtils";
import initialCall, { initialCallPaths } from "@helpers/initial-call";
import { GetStaticPathsContext } from "next";
import { PLACE_HOLDER_IMAGE_PATH } from "@lib/sharedUtils";
import {
    IBestOverallPageProps,
    ICustomDomain,
    TranslationsObject,
} from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";

const Pg = ({ title }: { title: string }) => {
    const [comparisonList] = useAtom(comparisonVendors);
    const { data: props } = useQuery<IBestOverallPageProps, Error>([
        "bestOverallPageProps",
    ]);
    const { data: domainInfo } = useQuery<ICustomDomain, Error>({
        queryKey: ["domain"],
    });
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const { category } = props ?? {};

    return (
        <>
            <MetaTags
                title={
                    title
                        ? `${translate(
                              translations,
                              "several_category_mainTab_bestOverAll",
                          )} ${title} ${translate(
                              translations,
                              "several_siteMapPage_Vendors",
                          )} | Several.com`
                        : `${`${translate(
                              translations,
                              "several_category_mainTab_bestOverAll",
                          )} ${
                              (category?.label as string)
                                  ? (category?.label as string)
                                  : (category?.name as string)
                          } ${translate(
                              translations,
                              "several_siteMapPage_Vendors",
                          )}`} | Several.com`
                }
                image={
                    (category?.mainImage?.fullPath as string) ??
                    PLACE_HOLDER_IMAGE_PATH
                }
                description={
                    getCategoriesDescription(
                        category as GQLCategories,
                        domainInfo?.domain as GQLDomains,
                        translate(
                            translations,
                            "several_general_meta_description",
                        ),
                    ) as string
                }
                keyWords={
                    getCategoriesKeyWords(
                        category as GQLCategories,
                        domainInfo?.domain as GQLDomains,
                    ) as string
                }
                url={`${resolveURL(category?.url as GQLUrls)}/comparison`}
            />
            <CategoryTemplate>
                <section className="lg:my-16 mb-16">
                    <BestOverAll />
                </section>

                {comparisonList.length > 0 && (
                    <StickyComponent url={category?.url as GQLUrls} />
                )}
            </CategoryTemplate>
        </>
    );
};

export function getStaticPaths() {
    return initialCallPaths();
}

export async function getStaticProps(ctx: GetStaticPathsContext) {
    return await initialCall("BestOverAllByCategoryId", ctx);
}
export default Pg;
